export default "__VITE_ASSET__BFsG74WD__"